export const servicesCols = [
  "Service Code",
  "Description",
  "Purpose",
  "Type",
  "Url",
  "Valid",
  "Direction",
  "Definition",
  "Port",
  "API Key",
  "Certificate",
  "Certificate Password",
  "Certificate Description",
  "Certificate Valid To",
  "Mail",
  "Reply To",
  "Mail Sender Name",
  "Login Username",
  "Login Password",
  "Notes",
  "Registration Date to Service",
  "User Created",
  "Time of Creation",
];

export const servicesFields = [
  {
    name: "ServiceEndPointCode",
    isPass: false,
    isEmail: false,
    type: "text",
    group: "service",
  },
  {
    name: "ServiceEndPointCode__Description",
    isPass: false,
    isEmail: false,
    type: "text",
    group: "service",
  },
  {
    name: "ServiceEndPointCode__Purpose",
    isPass: false,
    isEmail: false,
    type: "text",
    group: "service",
  },
  {
    name: "ServiceEndPointCode__Type",
    isPass: false,
    isEmail: false,
    type: "select",
    group: "service",
  },
  {
    name: "ServiceEndPointCode__URL",
    isPass: false,
    isEmail: false,
    type: "text",
    group: "service",
  },
  {
    name: "Valid",
    isPass: false,
    isEmail: false,
    type: "bool",
    group: "service",
  },
  {
    name: "Direction",
    isPass: false,
    isEmail: false,
    type: "select",
    group: "service",
  },
  {
    name: "Definition",
    isPass: false,
    isEmail: false,
    type: "text",
    group: "service",
  },
  {
    name: "Port",
    isPass: false,
    isEmail: false,
    type: "text",
    group: "service",
  },
  {
    name: "APIKey",
    isPass: false,
    isEmail: false,
    type: "text",
    group: "service",
  },
  {
    name: "Certificate",
    isPass: false,
    isEmail: false,
    type: "text",
    group : "cert",
  },
  {
    name: "CertPass",
    isPass: true,
    isEmail: false,
    type: "text",
    group : "cert",
  },
  {
    name: "CertDesc",
    isPass: false,
    isEmail: false,
    type: "text",
    group : "cert",
  },
  {
    name: "CertValidTo",
    isPass: false,
    isEmail: false,
    type: "text",
    group : "cert",
  },
  {
    name: "Mail",
    isPass: false,
    isEmail: true,
    type: "text",
    group: "mail",
  },
  {
    name: "ReplyTo",
    isPass: false,
    isEmail: false,
    type: "text",
    group: "mail",
  },
  {
    name: "MailSenderName",
    isPass: false,
    isEmail: false,
    type: "text",
    group: "mail",
  },
  {
    name: "LoginUsername",
    isPass: false,
    isEmail: false,
    type: "text",
    group : "login",
  },
  {
    name: "LoginPass",
    isPass: true,
    isEmail: false,
    type: "text",
    group : "login",
  },
  {
    name: "Notes",
    isPass: false,
    isEmail: false,
    type: "text",
  },
  {
    name: "RegDateToService",
    isPass: false,
    isEmail: false,
    type: "text",
  },
  {
    name: "UserCreate",
    isPass: false,
    isEmail: false,
    type: "text",
  },
  {
    name: "DateTimeCreate",
    isPass: false,
    isEmail: false,
    type: "text",
  },
];


